<template>
	<div>
		<div ref="filtersWrapper" class="dc-post-grid-filters-wrapper" v-if="filters">
			<template v-for="filter in filters">
				<h3 v-if="filter.name === 'label'">{{ filter.value }}</h3>

				<div
					:class="['dc-post-grid-search-wrapper']"
					v-else-if="filter.type === 'default' && filter.name === 'search'"
				>
					<Search
						:model="filter.value ? filter.value : form.s"
						:searchFormPlaceholder="filter.placeholder"
						v-on:updateSearchTerm="_updateAndSearch"
					/>
				</div>

				<Dropdown
					v-else-if="filter.type === 'default'"
					:label="filter.label"
					:name="filter.name"
					:options="filter.options"
					:model="form[filter.name] || []"
					:multiselect="filter.multiselect"
					:initialSelection="filter.initial_selection"
					:showAllOption="filter.show_all_option"
					:open="filter.name === openFilter"
					v-on:toggle-filter="toggleFilter"
					v-on:update-filter="_updateAndSearch"
					v-on:reset-filter="_resetAndSearch"
				/>

				<CourseDescription v-if="courseDesc && filter.name === 'dc_course_category'" :text="courseDesc" />
			</template>

			<input
				v-on:click.stop.prevent="search"
				:id="searchButtonId"
				type="submit"
				tabindex="-1"
				:class="['screen-reader-text', { loading: loading }]"
				:value="Search"
			/>
		</div>
	</div>
</template>

<script>
import Filters from '@dc-post-grid/layout/Filters.vue';
import CourseDescription from './ui/CourseDescription.vue';
export default {
	extends: Filters,
	data() {
		return {
			courseDesc: null,
		};
	},
	methods: {
		_updateAndSearch(name, newValue, usesMultiselect) {
			this.updateAndSearch(name, newValue, usesMultiselect);
			this.updateCourseDesc(name, newValue);
		},
		_resetAndSearch(name) {
			this.resetAndSearch(name);
			this.updateCourseDesc(name, null);
		},
		updateCourseDesc(name, newValue) {
			if (name !== 'dc_course_category') return;
			const courseTaxes = this.filters.find((f) => f.name === 'dc_course_category');
			const selectedCourseTax = courseTaxes.options.find((t) => t.value === newValue);
			if (selectedCourseTax && selectedCourseTax.description) {
				this.courseDesc = selectedCourseTax.description;
			} else {
				this.courseDesc = null;
			}
		},
	},
	components: {
		CourseDescription,
	},
};
</script>
